/* Built In Imports */

/* External Imports */
import { Box } from "@chakra-ui/react";

/* Internal Imports */
import SectionTitle from '@components/Headings/SectionTitle';
import TopKolam from '@components/Headings/TopKolam';
import ApplyStepV2 from '@landing_pages/hytt/components/ApplyStepV2';
import config from '@config';

/* Services */

const HowtoApplyV2 = ({ sectionContent, region, lang, section }) => {
    return (
        <Box marginTop="0px">
            <Box mb="10px">
                {/* <SectionTitle
                    titleObj={sectionContent[0]}
                    titleDecoration={sectionContent[0]?.titleDecoration}
                    mx={{ base: '17px', md: 'auto' }}
                    fontSize={{ base: "30px", sm: "30px", md: "" }}
                    color={'#ffffff'}
                /> */}
                <Box
                    width={{ sm: "282px", base: "282px", md: "auto" }}
                    color="white"
                    fontWeight={'500'}
                    fontSize={{base:"32px",md:"32px",sm:"30px",lg:"32px"}}
                    mx={{ base: '17px', md: 'auto' }}
                    lineHeight={{ base: "37px", sm: "37px", md: "37px" }}
                    fontFamily={'FedraSansStd-A-medium'}
                    textAlign={'center'}
                    margin={'auto'}
                    marginTop={"30px"}
                >
                    {sectionContent[0].titleText}
                </Box>

                <Box marginTop={"10px"}>
                    <TopKolam
                        sectionContent={sectionContent[1]}
                    />
                </Box>
                <Box 
                    width={{base:'90%', md:'720px'}} 
                    m="0 auto"
                    backgroundImage={{
                        base: `${config.imgPath}/d/46272/1712840772-howtoapply_steps_mobile1.png`,
                        md: section?.styleConfig?.bgImage?.url,
                      }}
                    backgroundRepeat={{base:'no-repeat', lg:'repeat-y'}} 
                    backgroundPosition={{base:'top center', md:'top center'}}
                    backgroundSize={{base:'cover', md:'contain'}}
                    // height={{base:'2250px'}}
                >
                    {sectionContent[2]?.cards.map((card, index) => {
                        const isEvenIndex = index % 2 === 0;
                        const alignDirection = isEvenIndex ? 'flex-start' : 'flex-end';
                        const margnleft = isEvenIndex ? '0px' : 'auto';
                            return (
                                <ApplyStepV2 card={card} index={index} btn={sectionContent[3]} region={region} lang={lang} bgcolor={section?.styleConfig?.bgColour?.hex}/>
                            );
                        })}
                </Box>
            </Box>
            <style jsx global>
                {`
                    .step_icon img {
                        max-width: none;
                        width: 54px !important
                    }
                        
                `}
            </style>
        </Box>
    );
};

export default HowtoApplyV2